module.exports = __webpack_public_path__ + "img/car-1.3efdb85c.png";